import { stateMap } from '../stateMap'
import { DownloadTemplateButton } from './DownloadTemplateButton'
import { LogItemContent } from './LogItemContent'
import Timeline from './Timeline'
import { TimeLineItem, TimelineItemContent, TimelineItemIcon } from './TimeLineItem'
import { CompletedAction } from './next-actions/CompletedAction'
import { ReviewAction } from './next-actions/ReviewAction'
import { StartAction } from './next-actions/StartAction'
import { RestSchemas } from '@/contexts/QueryProvider'
import { IconV2CommentOutline } from '@icons/IconV2CommentOutline'

type LogItem = RestSchemas['Messages.Templates.TTemplateActivity']

function renderNextAction(lastActivity: LogItem) {
  switch (lastActivity.state) {
    case 'Accepted':
      return CompletedAction
    case 'Uploaded':
      return ReviewAction
    default:
      return StartAction
  }
}

export function ActivityLogV2Content({
  activityLog,
  lastActivity,
  url,
  updatedText,
  handleDownloadTemplate,
  isPending,
  entityId,
  templateId,
}: {
  activityLog: LogItem[]
  lastActivity: LogItem
  url: string
  updatedText: string
  handleDownloadTemplate: () => void
  isPending: boolean
  entityId: number
  templateId: number
}) {
  const NextAction = renderNextAction(lastActivity)
  return (
    <div className="pt-5">
      {url && (
        <DownloadTemplateButton updatedText={updatedText} onClick={handleDownloadTemplate} disabled={isPending} />
      )}
      <Timeline>
        <>
          {activityLog
            .filter((logItem) => logItem.state !== 'None')
            .map((logItem) => {
              const validState = logItem.state in stateMap ? (logItem.state as keyof typeof stateMap) : 'None'
              const isComment = logItem.activity === 'Comment'
              const Icon = isComment ? IconV2CommentOutline : stateMap[validState].icon
              return (
                <TimeLineItem key={logItem.date}>
                  <TimelineItemIcon
                    Icon={Icon}
                    variant={
                      isComment
                        ? 'outline'
                        : stateMap[validState].variant === 'info'
                          ? 'outline'
                          : stateMap[validState].variant
                    }
                  />
                  <TimelineItemContent>
                    <LogItemContent {...logItem} />
                  </TimelineItemContent>
                </TimeLineItem>
              )
            })}
          <TimeLineItem>
            <TimelineItemIcon Icon={null} />
            <TimelineItemContent>
              <NextAction entityId={entityId} templateId={templateId} lastActivity={lastActivity} />
            </TimelineItemContent>
          </TimeLineItem>
        </>
      </Timeline>
    </div>
  )
}
